/* ==========================================================================
   Atelier — theme scripts (vanilla, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.themeStrings || {};

  /* ---------- helpers ---------- */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }

  function formatMoney(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = format
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    return out;
  }
  window.formatMoney = formatMoney;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function trapFocus(container) {
    var focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return function () {};
    var first = focusables[0], last = focusables[focusables.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    setTimeout(function () { first.focus(); }, 60);
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- overlay + drawer manager ---------- */

  var overlay = $('[data-overlay]');
  var openPanels = [];
  var releaseFocus = null;

  function showOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    setTimeout(function () { if (!openPanels.length) overlay.hidden = true; }, 350);
  }

  function openPanel(panel) {
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    openPanels.push(panel);
    showOverlay();
    releaseFocus = trapFocus(panel);
  }

  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== panel; });
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
    if (!openPanels.length) {
      document.body.classList.remove('drawer-open');
      hideOverlay();
    }
  }

  function closeAllPanels() {
    openPanels.slice().forEach(closePanel);
  }
  window.closeAllPanels = closeAllPanels;

  on(overlay, 'click', closeAllPanels);
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllPanels();
      $$('.facet[open]').forEach(function (f) { f.removeAttribute('open'); });
    }
  });

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-panel-open]');
    if (openTrigger) {
      e.preventDefault();
      var target = $(openTrigger.getAttribute('data-panel-open'));
      if (target) {
        if (target.classList.contains('is-open')) closePanel(target);
        else { closeAllPanels(); openPanel(target); }
        var input = $('input[type="search"]', target);
        if (input) setTimeout(function () { input.focus(); }, 300);
      }
      return;
    }
    var closeTrigger = e.target.closest('[data-panel-close]');
    if (closeTrigger) {
      e.preventDefault();
      closePanel(closeTrigger.closest('.drawer, .search-drawer, .popup'));
    }
  });

  /* ---------- sticky header ---------- */

  var headerWrapper = $('[data-header]');
  if (headerWrapper) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      headerWrapper.classList.toggle('is-scrolled', y > 10);
      lastScroll = y;
    }, { passive: true });
  }

  /* ---------- mobile nav accordions ---------- */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mobile-toggle]');
    if (!toggle) return;
    var panel = toggle.nextElementSibling;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.classList.toggle('is-open', !expanded);
  });

  /* ---------- accordions ---------- */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.accordion__toggle');
    if (!toggle) return;
    var panel = toggle.nextElementSibling;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.setAttribute('data-open', String(!expanded));
  });

  /* ---------- back to top ---------- */

  var backToTop = $('[data-back-to-top]');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('is-visible', window.pageYOffset > 700);
    }, { passive: true });
    on(backToTop, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- scroll reveal ---------- */

  function initReveal(scope) {
    if (!window.themeSettings || !window.themeSettings.animations) return;
    if (!('IntersectionObserver' in window)) {
      $$('.reveal', scope).forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal', scope).forEach(function (el) { io.observe(el); });
  }
  initReveal(document);

  /* ---------- announcement bar rotator ---------- */

  $$('[data-announcement]').forEach(function (bar) {
    var slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    var index = 0;
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;
    var timer;
    function go(i) {
      slides[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }
    function start() { timer = setInterval(function () { go(index + 1); }, speed); }
    function reset() { clearInterval(timer); start(); }
    on($('[data-announcement-prev]', bar), 'click', function () { go(index - 1); reset(); });
    on($('[data-announcement-next]', bar), 'click', function () { go(index + 1); reset(); });
    start();
  });

  /* ---------- slideshow ---------- */

  function initSlideshow(root) {
    var track = $('[data-slideshow-track]', root);
    if (!track) return;
    var slides = $$('.slideshow__slide', track);
    if (slides.length < 2) {
      $$('.slider-nav, .slideshow__controls', root).forEach(function (el) { el.style.display = 'none'; });
      return;
    }
    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
    var dots = $$('[data-slideshow-dot]', root);
    var timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      slides.forEach(function (s, si) { s.setAttribute('aria-hidden', String(si !== index)); });
    }
    function start() { if (autoplay) timer = setInterval(function () { go(index + 1); }, speed); }
    function stop() { clearInterval(timer); }

    on($('[data-slideshow-prev]', root), 'click', function () { go(index - 1); stop(); start(); });
    on($('[data-slideshow-next]', root), 'click', function () { go(index + 1); stop(); start(); });
    dots.forEach(function (dot, di) { on(dot, 'click', function () { go(di); stop(); start(); }); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 50) { go(delta < 0 ? index + 1 : index - 1); stop(); start(); }
      startX = null;
    });

    go(0);
    start();
  }
  $$('[data-slideshow]').forEach(initSlideshow);

  /* ---------- horizontal scroller arrows ---------- */

  function initScroller(root) {
    var scroller = $('[data-scroller]', root);
    if (!scroller) return;
    var prev = $('[data-scroller-prev]', root);
    var next = $('[data-scroller-next]', root);
    function amount() { return scroller.clientWidth * 0.8; }
    on(prev, 'click', function () { scroller.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    on(next, 'click', function () { scroller.scrollBy({ left: amount(), behavior: 'smooth' }); });
    function update() {
      if (!prev || !next) return;
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      prev.style.opacity = scroller.scrollLeft <= 2 ? '0.3' : '1';
      next.style.opacity = scroller.scrollLeft >= max ? '0.3' : '1';
    }
    scroller.addEventListener('scroll', debounce(update, 80), { passive: true });
    update();
  }
  $$('[data-scroller-root]').forEach(initScroller);

  /* ---------- marquee duplication ---------- */

  $$('[data-marquee-track]').forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  /* ---------- cart ---------- */

  function updateCartCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
  }

  function refreshCartDrawer(openAfter) {
    return fetch(routes.cart_url + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart);
        if (openAfter) {
          var drawer = $('#CartDrawer');
          if (drawer && !drawer.classList.contains('is-open')) { closeAllPanels(); openPanel(drawer); }
        }
        return cart;
      });
  }
  window.refreshCartDrawer = refreshCartDrawer;

  function addToCart(formData, button) {
    var original = button ? button.innerHTML : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.innerHTML = '<span class="spinner"></span>'; }

    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (button) { button.innerHTML = res.data.description || res.data.message || 'Error'; }
          setTimeout(function () {
            if (button) { button.innerHTML = original; button.removeAttribute('aria-disabled'); }
          }, 2500);
          return null;
        }
        if (button) {
          button.innerHTML = strings.added || 'Added';
          setTimeout(function () { button.innerHTML = original; button.removeAttribute('aria-disabled'); }, 1600);
        }
        var isDrawer = window.themeSettings && window.themeSettings.cartType === 'drawer';
        if (isDrawer) return refreshCartDrawer(true);
        window.location = routes.cart_url;
        return null;
      })
      .catch(function () {
        if (button) { button.innerHTML = original; button.removeAttribute('aria-disabled'); }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    if (window.themeSettings && window.themeSettings.cartType !== 'drawer' && !form.hasAttribute('data-ajax')) {
      // still ajax-add for quick add buttons
    }
    e.preventDefault();
    addToCart(new FormData(form), $('[data-add-button]', form));
  });

  function changeCartLine(line, quantity, row) {
    if (row) row.classList.add('loading');
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCartDrawer(false);
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeCartLine(parseInt(remove.getAttribute('data-line'), 10), 0, remove.closest('.cart-item'));
      return;
    }
    var qtyBtn = e.target.closest('[data-quantity-change]');
    if (qtyBtn) {
      e.preventDefault();
      var wrapper = qtyBtn.closest('.quantity');
      var input = $('input', wrapper);
      var dir = qtyBtn.getAttribute('data-quantity-change');
      var next = Math.max(parseInt(input.getAttribute('min') || '1', 10), parseInt(input.value, 10) + (dir === 'up' ? 1 : -1));
      if (dir === 'down' && parseInt(input.value, 10) <= parseInt(input.getAttribute('min') || '1', 10)) {
        if (input.hasAttribute('data-cart-line')) next = 0; else return;
      }
      input.value = next;
      if (input.hasAttribute('data-cart-line')) {
        changeCartLine(parseInt(input.getAttribute('data-cart-line'), 10), next, qtyBtn.closest('.cart-item'));
      }
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('[data-cart-line]')) return;
    changeCartLine(parseInt(input.getAttribute('data-cart-line'), 10), parseInt(input.value, 10), input.closest('.cart-item'));
  });

  /* cart note */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    fetch(routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  });

  /* ---------- quick add (from card) ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    var url = btn.getAttribute('data-product-url');
    if (!variantId && url) { window.location = url; return; }
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    addToCart(fd, btn);
  });

  /* ---------- product page ---------- */

  function initProduct(root) {
    var form = $('[data-product-form]', root);
    var dataEl = $('[data-variants-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = $('[data-variant-id]', root);
    var addButton = $('[data-add-button]', root);
    var priceWrap = $('[data-price-wrapper]', root);
    var skuEl = $('[data-sku]', root);
    var stockEl = $('[data-stock]', root);

    function currentOptions() {
      return $$('[data-option-index]', root)
        .filter(function (el) { return el.checked || el.tagName === 'SELECT'; })
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (el) { return el.value; });
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var target = $('[data-media-id="' + variant.featured_media.id + '"]', root);
      if (!target) return;
      var list = $('[data-media-list]', root);
      if (list && window.innerWidth < 990) {
        list.scrollTo({ left: target.offsetLeft - list.offsetLeft, behavior: 'smooth' });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      $$('.product__thumb', root).forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb-id') === String(variant.featured_media.id));
      });
    }

    function update() {
      var opts = currentOptions();
      var variant = matchVariant(opts);

      // reflect selected value labels
      $$('[data-selected-value]', root).forEach(function (el, i) {
        if (opts[i]) el.textContent = opts[i];
      });

      if (!variant) {
        if (addButton) { addButton.setAttribute('disabled', 'disabled'); addButton.innerHTML = strings.unavailable || 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (addButton) {
        if (variant.available) {
          addButton.removeAttribute('disabled');
          addButton.innerHTML = strings.addToCart || 'Add to cart';
        } else {
          addButton.setAttribute('disabled', 'disabled');
          addButton.innerHTML = strings.soldOut || 'Sold out';
        }
      }

      if (priceWrap) {
        var html = '<span class="price price--large' + (variant.compare_at_price > variant.price ? ' price--on-sale' : '') + '">';
        if (variant.compare_at_price > variant.price) {
          html += '<span class="price__sale">' + formatMoney(variant.price) + '</span>';
          html += '<span class="price__regular">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          html += '<span>' + formatMoney(variant.price) + '</span>';
        }
        html += '</span>';
        priceWrap.innerHTML = html;
      }

      if (skuEl) skuEl.textContent = variant.sku || '';

      if (stockEl) {
        var qty = variant.inventory_quantity;
        var policy = variant.inventory_management;
        stockEl.className = 'stock-counter';
        var label = 'In stock, ready to ship';
        if (!variant.available) { stockEl.classList.add('stock-counter--out'); label = 'Out of stock'; }
        else if (policy && qty > 0 && qty <= 10) { stockEl.classList.add('stock-counter--low'); label = 'Low stock — only ' + qty + ' left'; }
        stockEl.innerHTML = '<span class="stock-counter__dot"></span><span>' + label + '</span>';
      }

      updateMedia(variant);

      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-index]', root).forEach(function (el) { on(el, 'change', update); });
    update();

    // thumbnails
    $$('.product__thumb', root).forEach(function (thumb) {
      on(thumb, 'click', function () {
        var id = thumb.getAttribute('data-thumb-id');
        var target = $('[data-media-id="' + id + '"]', root);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        $$('.product__thumb', root).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // image zoom
    $$('[data-zoom]', root).forEach(function (media) {
      on(media, 'click', function (e) {
        media.classList.toggle('is-zoomed');
        if (media.classList.contains('is-zoomed')) {
          var rect = media.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          var img = $('img', media);
          if (img) img.style.transformOrigin = x + '% ' + y + '%';
        }
      });
    });
  }
  $$('[data-product-root]').forEach(initProduct);

  /* ---------- predictive search ---------- */

  var searchInput = $('[data-predictive-input]');
  var searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    var runSearch = debounce(function () {
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      var url = routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page&resources[limit]=6&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          searchResults.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function () { searchResults.innerHTML = ''; });
    }, 260);
    on(searchInput, 'input', runSearch);
  }

  /* ---------- facets (collection filtering) ---------- */

  function initFacets() {
    var form = $('[data-facet-form]');
    if (!form) return;

    function renderFrom(html, url) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['[data-product-grid]', '[data-facet-form]', '[data-active-facets]', '[data-collection-count]', '[data-pagination]'].forEach(function (sel) {
        var fresh = doc.querySelector(sel);
        var current = $(sel);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        else if (!fresh && current) current.innerHTML = '';
      });
      if (url) history.pushState({ url: url }, '', url);
      initReveal(document);
      window.scrollTo({ top: $('[data-product-grid]').offsetTop - 140, behavior: 'smooth' });
    }

    function submitFacets() {
      var params = new URLSearchParams(new FormData(form)).toString();
      var url = window.location.pathname + (params ? '?' + params : '');
      var grid = $('[data-product-grid]');
      if (grid) grid.style.opacity = '0.4';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) { renderFrom(html, url); if (grid) grid.style.opacity = ''; });
    }

    document.addEventListener('change', function (e) {
      if (!e.target.closest('[data-facet-form]')) return;
      submitFacets();
    });

    document.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-facet-remove]');
      if (!clear) return;
      e.preventDefault();
      var url = clear.getAttribute('href');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) { renderFrom(html, url); });
    });

    window.addEventListener('popstate', function () {
      fetch(window.location.href).then(function (r) { return r.text(); }).then(function (html) { renderFrom(html, null); });
    });

    // close facet dropdowns on outside click
    document.addEventListener('click', function (e) {
      if (e.target.closest('.facet')) return;
      $$('.facet[open]').forEach(function (f) { f.removeAttribute('open'); });
    });
  }
  initFacets();

  /* ---------- popup ---------- */

  $$('[data-popup]').forEach(function (popup) {
    var key = 'atelier-popup-' + popup.id;
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 5000;
    var days = parseInt(popup.getAttribute('data-frequency'), 10) || 7;
    var seen = null;
    try { seen = localStorage.getItem(key); } catch (err) {}
    if (seen && Date.now() - parseInt(seen, 10) < days * 86400000) return;
    setTimeout(function () {
      popup.classList.add('is-open');
      showOverlay();
      openPanels.push(popup);
    }, delay);
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-panel-close]')) {
        try { localStorage.setItem(key, String(Date.now())); } catch (err) {}
      }
    });
    var form = $('form', popup);
    if (form) on(form, 'submit', function () { try { localStorage.setItem(key, String(Date.now())); } catch (err) {} });
  });

  /* ---------- age verifier ---------- */

  var ageGate = $('[data-age-gate]');
  if (ageGate) {
    var passed = null;
    try { passed = localStorage.getItem('atelier-age-ok'); } catch (err) {}
    if (passed) { ageGate.remove(); }
    else {
      ageGate.hidden = false;
      document.body.classList.add('drawer-open');
      on($('[data-age-confirm]', ageGate), 'click', function () {
        try { localStorage.setItem('atelier-age-ok', '1'); } catch (err) {}
        ageGate.remove();
        document.body.classList.remove('drawer-open');
      });
      on($('[data-age-deny]', ageGate), 'click', function () { window.location = 'https://www.google.com'; });
    }
  }

  /* ---------- Shopify theme editor re-init ---------- */

  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target;
    initReveal(scope);
    $$('[data-slideshow]', scope).forEach(initSlideshow);
    $$('[data-scroller-root]', scope).forEach(initScroller);
    $$('[data-product-root]', scope).forEach(initProduct);
    $$('[data-marquee-track]', scope).forEach(function (t) { t.innerHTML = t.innerHTML + t.innerHTML; });
    initFacets();
  });

  document.addEventListener('shopify:section:select', function (e) {
    var drawer = e.target.querySelector('.drawer, .popup');
    if (drawer) openPanel(drawer);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var drawer = e.target.querySelector('.drawer, .popup');
    if (drawer) closePanel(drawer);
  });
})();
